export const SettingsPaths = {
  EnvironmentStatus: "status",
  EnvironmentConfiguration: "configuration",
  Monitors: "monitors",
} as const;
